import React from 'react';
import Heading from "@scentregroup/ui/components/heading";
import { MarketplaceContainer } from '../marketplace-container';
import { jsx as _jsx } from "react/jsx-runtime";

const PageHeading = ({
  title
}) => /*#__PURE__*/_jsx(MarketplaceContainer, {
  children: /*#__PURE__*/_jsx(Heading, {
    type: "large",
    children: title
  })
});

export default PageHeading;